import dynaForms from '@elab/core/utils/dynaForms';
import dynaFormsApi from '@elab/core/utils/dynaForms/api';

export default storeName => formId => [
    ...dynaForms.createSagaFor(storeName, dynaFormsApi.getFormMetadata(formId || storeName)),
];
